import { useNotificationStore } from '../store/useNotificationStore';
import { NotificationServiceImpl } from './NotificationServiceImpl';
import { INotificationService } from './INotificationService';
import { NotificationServiceLogDecorator } from './NotificationServiceLogDecorator';
import { NotificationServiceExceptionDecorator } from './NotificationServiceExceptionDecorator';

export class NotificationServiceFactory {
  private static instance: NotificationServiceFactory | null = null;
  private notificationStore: typeof useNotificationStore;

  public static initialize(notificationStore: typeof useNotificationStore) {
    NotificationServiceFactory.instance = new NotificationServiceFactory(notificationStore);
  }

  public static getInstance() {
    if (NotificationServiceFactory.instance === null) {
      throw new Error(
        'NotificationServiceFactory not yet initialized. Call NotificationServiceFactory.initialize() first.',
      );
    }
    return NotificationServiceFactory.instance;
  }

  private constructor(notificationStore: typeof useNotificationStore) {
    this.notificationStore = notificationStore;
  }

  public createNotificationService(): INotificationService {
    let result: INotificationService = this.makeNotificationService();

    result = new NotificationServiceExceptionDecorator(result);
    result = new NotificationServiceLogDecorator(result);

    return result;
  }

  private makeNotificationService(): INotificationService {
    return new NotificationServiceImpl(this.notificationStore);
  }
}
